import {ISelectFilter, ISelectFilterOption} from 'PyzShopUi/scripts/shop-ui/components/search-page/interfaces';
import {IApiQueryData} from 'PyzShopUi/scripts/product-review/interfaces';

export default class SelectFilterUtils {
    public static getOptionsByName = (filters: ISelectFilter[], optionName: string, defaultParams: any = []): ISelectFilterOption[] | [] => {
        return filters?.find(option => option.name === optionName)?.options || defaultParams
    }

    public static getCurrentOption = (options: ISelectFilterOption[], defaultOption: string): string  => {
        return options.find(option => option.selected)?.value || defaultOption;
    }

    public static isMultipleFilterSelect = (apiQueries: IApiQueryData, options: string[]): boolean  => {
        if (!options.length) {
            return true;
        }
        for (const key of options) {
            if (!(key in apiQueries) || !apiQueries[key]) {
                return false;
            }
        }

        return true;

    }
}
